import { render, staticRenderFns } from "./RequiresGlobalPermissions.vue?vue&type=template&id=e3eb77ca&"
import script from "./RequiresGlobalPermissions.vue?vue&type=script&lang=js&"
export * from "./RequiresGlobalPermissions.vue?vue&type=script&lang=js&"
import style0 from "./RequiresGlobalPermissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports